<script lang="ts" setup>

  // pinia storage
  import { storeToRefs } from 'pinia';
  import { usePageStore } from '@/store/page';

  // nyelvi es routing beallitasok
  // const localePath = useLocalePath();
  const { t, locale } = useI18n();
  const route = useRoute();

  // page setup:
  const pageStore = usePageStore();
  pageStore.setBgimgurl('/shop/23.png');
  pageStore.setTitle(t('About us'));
  const { title } = storeToRefs(pageStore);
  pageStore.setCrumbs([{ title: title.value, to: route.path }]);

  definePageMeta({ 
    // layout: 'default',
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      hu: '/rolunk',
      en: '/about-us',
    }
  })

  // nuxt content setup:
  // sajnos ez csak akkor hasznalhato ha teljes page strukturat kap a nuxt content
  // const { toc } = useContent()

  const contenthu = `
## A Bestsellersről

A Bestsellers könyvesbolt 1992 szeptemberében nyílt meg az Október 6. utca 11. szám alatt. Előtte egy csemegebolt működött a helyén. 1995-től kilenc éven át működtettünk egy kifejezetten a társadalomtudományokra szakosodott könyvesboltot a Közép-Európai Egyetem területén. 2004-ben megadatott a lehetőség, hogy kibővítsük az eredeti üzlethelyiséget, és azóta egy fedél alatt működtetünk általános és egyetemi könyvesboltot.
Idegen nyelvű újságokat és magazinokat is árusítunk; ennek köszönhetően is váltunk számos törzsvásárlónk kedvenc célállomásává, ahol egy helyen több mindent is beszerezhet.

<figure class="text-center">
  <img src="/shop/20.jpg" alt="A csemegebolt, aminek helyén az eredeti Bestsellers könyvesbolt létrejött." class="w-full h-auto mx-auto block" />
  <figcaption class="italic text-sm">A csemegebolt, aminek helyén az eredeti Bestsellers könyvesbolt létrejött.</figcaption>
</figure>

A Bestsellers jelmondata így szól: "A könyveken át a tudásig és az álmokig", célunk pedig a legjobb, frissen megjelent könyvek havi szinten történő bemutatása, valamint vásárlóink megrendeléseinek teljesítése, akik tanulás vagy munka céljából, vagy éppen az olvasás szeretetétől vezérelve rendelnek könyveket. Ezen a területen Budapest belvárosában már vezető könyvesboltnak számítunk. Hosszú távú együttműködéseink lehetővé teszik, hogy online hozzáférést nyújthassunk egy több mint 5 milliós könyv adatbázishoz, mely folyamatosan frissül, így a felhasználóink valós idejű készletet láthatnak a webshopban illetve a partnereink raktárában.

<figure class="text-center">
  <img src="/shop/09.jpg" alt="A Bestsellers könyvesbolt" class="w-full h-auto mx-auto block" />
  <figcaption class="italic text-sm">A Bestsellers könyvesbolt 2021. szeptemberében</figcaption>
</figure>

Boltunk választékát gondos könyvbeszerzőink alakítják, akik közvetlenül a világ legnagyobb könyvkiadó csoportjaitól, valamint egyetemi és számos kisebb, független kiadótól rendelnek. A polcainkon sorakozó címek tükrözik törzsvásárlóink ízlését is, akiknek olyan könyveket igyekszünk választani, amiket reményeink szerint érdekesnek találnak, és amiket elolvasva új felfedezéseket tehetnek. Tudjuk, miként ragadjuk meg az uralkodó korszellemet, ugyanakkor olyan klasszikusokat is ajánlunk, akiknek ismét eljöhet az ideje. Röviden, a célunk nem más, mint megkísérteni és meglepni az olvasót, egyben a felfedezés örömét nyújtani.

## Miért válassza a Bestsellers-t?

Köztiszteletnek örvendő, független könyvesbolt vagyunk, 1992 óta Budapest szívében működünk. Széles körű szakértelmünknek és személyes hangvételű ügyfélszolgálatunknak köszönhetően úgy véljük, sokkal meghatározóbb élményt kínálunk, mint egy arctalan online könyvesbolt.

### Áraink versenyképesek.

Ha eddig nagy nemzetközi cégektől vásárolt az alacsonyabb ár miatt, tegyen egy próbát nálunk, hadd lepjük meg! Ha Budapesten él, vásároljon helyben!

Honlapunk egyben olyan export és korai exportkiadványokat is kínál, amelyek gyakran csak a repülőtereken szerezhetőek be, de általában nem kaphatóak a nagy brit vagy amerikai könyvesboltokban sem. Mi minden esetben a legjobbat kínáljuk.

Könyvadatbázisunk teljesen naprakész, a nappali órákban 10 percenkét frissül, így valós idejű készletinformációk állnak a rendelkezésére mind boltunkról, mind a nagykereskedőktől.

Ha a megvásárolni kívánt könyv nem kapható boltunkban, jó eséllyel lesz nagykereskedelmi partnerünknél, amit a honlapunkon meg is talál, és máris leadhatja rá a megrendelését.

Foglalja le online-vegye át a boltban! Nincs postaköltség, fizethet bankkártyával, PayPallal vagy készpénzzel.

Könyvmegrendelése nem vész el, nem sérül meg a kiszállításnál, mivel magán kiszállítókkal vagy futárokkal dolgozunk, nem a postai rendszert használjuk, és addig őrizzük a könyvét, míg érte nem jön.

A Bestsellers független könyvesbolt, és minden eladónk érdekelt a cégben. Az Önök vásárlása működtet minket - tegyenek hát bennünket próbára!

Igazi, jól felkészült eladóink vannak, átlagosan 17 éves szakmai tapasztalattal. Közvetlenül kapcsolatba léphet velünk telefonon, e-mailen vagy személyesen. Ha esetleg valamivel mégsem elégedett, személyesen állunk rendelkezésére, hogy meghallgassuk, magyarázattal szolgáljunk, és megoldást találjunk.

Ügyfélbarát cég vagyunk, nyugodtan böngészheti nálunk a polcokat, kérhet tanácsot, és mindig van aprónk. Kerüljük a bürokratikus megoldásokat, és szinte mindig találunk megoldást, ha felmerülne bármilyen probléma.

Népszerű a már nyomtatásban nem lévő könyveket kereső szolgáltatásunk: mondja el, hogy mire van szüksége, és mi jó eséllyel be tudjuk szerezni. Rengeteg különleges megrendelést bonyolítunk megfizethető áron.

A Bestsellers valós, létező könyvesbolt, amely Budapest belvárosában a hét minden napján várja a vásárlókat.

Bolti választékunk, -amibe nemcsak "bestsellerek" tartoznak, hanem annál sokkal több-, hetente bővül új könyvekkel.

## Csapatunk tagjai

<figure class="text-center float-left pt-4 pr-5">
  <img src="/shop/tony.png" alt="Tony Lang" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Tony Lang</figcaption>
</figure>

### Tony Lang

1992-ben nyitottam ezt a könyvesboltot, hogy a budapesti olvasók nagyobb választékból meríthessenek, mint ami akkor a rendelkezésükre állt. Több mint 20 évvel később ez a legjobb ilyen típusú könyvesbolt Budapesten, ami nagy részben hűséges ügyfeleinknek köszönhető. Munkatársaimmal egy csapatot alkotunk, amiben az én feladatom közreműködni mind a bolt fejlesztésében, mind abban, hogy kollégáim egyre több és több kötelezettségemet vegyék át, míg végül az én szerepem elhanyagolhatóvá válik, noha ez még nem most lesz. A Leicester Egyetemen végeztem (Társadalomtudományi alapképzés), 6 nyelven beszélek, eleget utazgattam a világban ahhoz, hogy többet ne kelljen utaznom, és kikapcsolódásként történelmi és filozófiai műveket olvasok.

<div class="clear"></div>

<figure class="text-center float-right pt-0 pl-5">
  <img src="/shop/kriszta.png" alt="Kriszta" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Kriszta</figcaption>
</figure>

### Kriszta

Szeretem a gyerekeket, ezért is tanultam eredetileg óvónőnek. Azután pályát módosítottam, és 2 éven át dolgoztam egy bankban, majd újabb 2 éven át egy textilboltban. Végül 1994-ben léptem be a Bestsellershez, és még ma is itt dolgozom. Én vagyok a boltvezető, így az én feladatom az összes adminisztráció, a logisztika, a koordinálás stb. Szekciók: regényirodalom, krimik és thrillerek, magyar történelem és irodalom. Legújabb hobbim a robogózás. Legfrissebb könyvélményeim: A 100 éves ember, szeretem Jill Mansellt, a krimi műfajában pedig nemrég fedeztem fel Gillian Flynnt.

<div class="clear"></div>

<figure class="text-center float-left pt-2 pr-5">
  <img src="/shop/melinda.png" alt="Melinda" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Melinda</figcaption>
</figure>

### Melinda

Véletlenül kezdtem el dolgozni a Bestsellersnél sok-sok éve: az Október 6. utcában éppen egy fagylaltost kerestem, amikor megláttam, hogy munkaerőt keresnek a könyvesboltba. Azóta is szívesen dolgozom itt, mivel nagyon kellemes hely, ahol minden nap kedves emberekkel találkozom, és jó könyvekre bukkanhatok. Az olasz, az orosz, a művészeti, a gyermek- és ifjúsági, valamint a kisebb tudományos szekciókért vagyok felelős. Egyben rengeteg háttérmunkát én végzek, illetve én kezelem a bolt Facebook oldalát.

<div class="clear"></div>

<figure class="text-center float-right pt-0 pl-5">
  <img src="/shop/gabor.png" alt="Gábor" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Gábor</figcaption>
</figure>

### Gábor

Hat éven át dolgoztam különböző pozíciókban Libri könyvesboltokban, mielőtt 2005-ben beléptem a Bestsellershez. Főleg fantasyt olvasok, időnként történelmi regényeket, történelmi fantasyt vagy bármit, ami felkelti az érdeklődésemet. Szekcióim: fantasy, tudományos fantasztikum, német nyelvű könyvek, francia nyelvű könyvek, jegyzetfüzetek és egyéb csecsebecsék. :) Lelkes MMO játékos vagyok, a GW2 király. :) Beleszerettem Prágába, és nemrégiben elkezdtem csehül tanulni.

<div class="clear"></div>

<figure class="text-center float-left pt-2 pr-5">
  <img src="/shop/mate.png" alt="Máté" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Máté</figcaption>
</figure>

### Máté

Rengeteg hajtűkanyarral a hátam mögött, a Bestsellers csapatához 2021 őszén csatlakoztam. Eredetileg az ELTE bölcsészkarán végeztem Filozófia szakirányon és Filmelmélet minoron, így leginkább ebben a két témában tudok segíteni könyvet ajánlani. Ezek mellett jelentős tapasztalatom van a színház világában és érdeklődöm a fantasy, a sci-fi és a költészet iránt. Éjszaka, a könyvesbolti rucimat ledobva, felöltöm rapper gúnyámat a La Tascen Trum zenekar MC-jeként és a rímeknek hódolok, vagy mint hobbi-programozó, fejlesztem a saját szerepjátékomat, melynek mesés világát előreláthatólag még hosszú évekig fogom építeni.

<div class="clear"></div>
`;

const contenten = `
## About Bestsellers

Bestsellers first opened its shop at number 11 Oktober 6. utca in September 1992. It was formerly a grocery store. From 1995 for 9 years we operated a dedicated academic bookshop specializing in the social sciences on the campus of the Central European University. In 2004 the opportunity came to expand the original shop and since then we operate as a general and academic bookshop under the same roof.
We also act as a newsagent for foreign newspapers and magazines making it a favorite one-stop destination for our many regular customers.

<figure class="text-center">
  <img src="/shop/20.jpg" alt="The grocery which became the original Bestsellers bookshop" class="w-full h-auto mx-auto block" />
  <figcaption class="italic text-sm">The grocery which became the original Bestsellers bookshop.</figcaption>
</figure>

Bestsellers' motto is "Through Books to Knowledge and Dreams" and our purpose is to showcase the best new books published every month and to order for our customers the books they need for study, work or the pleasure of reading. In this field we are already the leading bookseller in downtown Budapest. Our long-term partnerships enables us to offer online access to a database of over 5 million books which is completely up-to-date, and is refreshed every 10 minutes so that you can see real-time availability for stock in the shop and at our partners' warehouse.

<figure class="text-center">
  <img src="/shop/09.jpg" alt="Bestsellers shop" class="w-full h-auto mx-auto block" />
  <figcaption class="italic text-sm">Bestsellers in 2021. September</figcaption>
</figure>

The selection of books in our shop is carefully curated by our buyers who order titles directly from the main commercial publishers, as well as the University presses and many small, independent houses. The titles on our shelves also reflect the tastes and proclivities of our regular clients for whom we chose titles we believe they may find interesting and so open for them new avenues to explore. We know how to capture the prevailing Zeitgeist but we also propose classics whose time may have come again. In short, we aim to provide temptation, surprise and the joy of discovery.

## Why Bestsellers?

We are a respected, independent bookshop, based in central Budapest since 1992. With our extensive expertise and personal customer service, we think we offer a far better experience than an anonymous online bookstore.

### We are price competitive.

If you buy books from multinational companies for the lowest price, try us instead, let us surprise you! If you live local, buy local.

Our website also offers export and early export editions which are often available in airports but not usually available in the main bookshops of the UK or USA. We offer you the best of both worlds.

Our database of books is completely up-to-date, during day-time it is refreshed every 10 minutes and you get real-time availability for stock in the shop and at our wholesalers.

If the book you want is not in our shop, chances are our wholesaler will have it and you can see it on the website and still place your order.

Reserve online, collect in-store: no postage charges, you pay as you wish, credit card, PayPal or cash.

Your book order will not be lost or damaged in the mail, we use private transporters or couriers, not the mail system and we keep your book until collection.

Bestsellers is an independent bookshop and all our booksellers have a participation in the company. Your business keeps us going - put us to the test!

We have real, professional booksellers with an average experience of 17 years. You can contact us direct by phone, e-mail or in person. If, on the rare occasion that something goes wrong and you want to discuss it with us, we are here in person to listen, explain and find a solution.

We are customer friendly, you can browse in peace or ask for advice and we always have change. We are non-bureaucratic and we almost always find a solution if a problem should occur.

We have a popular Out-of-Print book search service, tell us what you need and chances are we can get it for you. We do a lot of special orders at affordable prices.

Bestsellers is a real, physical shop and it's in downtown Budapest open 7 days a week, we are only closed on some official public holidays.

Our selection of books in the shop, which includes much more than just "Bestsellers", receives new books every week.

## Members of our team

<figure class="text-center float-left pt-4 pr-5">
  <img src="/shop/tony.png" alt="Tony Lang" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Tony Lang</figcaption>
</figure>

### Tony Lang

I started this bookshop in 1992 to offer Budapest readers a better choice than was available at the time. More than 20 years later this is the best bookshop of its kind in Budapest thanks in great part to a loyal clientele. With my colleagues we work as a team and my task is to contribute to the development both of the shop and that of my colleagues to take on more and more of my responsibilities so that eventually I will become redundant, but not just yet. I'm a graduate of Leicester University (BA SOC SCI) I speak 6 languages, I've travelled the world enough not to need to travel much anymore and I read History and Philosophy for pleasure.

<div class="clear"></div>

<figure class="text-center float-right pt-0 pl-5">
  <img src="/shop/kriszta.png" alt="Kriszta" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Kriszta</figcaption>
</figure>

### Kriszta

I love children, that is why I originally trained to be a kindergarten teacher. I then switched careers and worked in a bank for 2 years and a further 2 years in a textile shop. Finally I joined Bestsellers in 1994 and I'm still here. I am the shop manager and hence deal with all the administration, logistics, co-ordination, etc.
..
Sections: Fiction, Crime and thrillers, Hungarian History + Literature

My most recent hobby is to ride a scooter. The books I enjoyed most recently are" The 100 Year old Man, and I like Jill Mansell and in crime I just discovered Gillian Flynn.

<div class="clear"></div>

<figure class="text-center float-left pt-2 pr-5">
  <img src="/shop/melinda.png" alt="Melinda" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Melinda</figcaption>
</figure>

### Melinda

I started working at Bestsellers by accident many-many years ago: I saw the advert for the job in the bookstore while looking for an ice-cream shop in October 6. street. I have enjoyed working here ever since, it's a very pleasant place where you can meet nice people and find good books every day.
I am responsible for the Italian, the Russian, the Art, the Children's and the Young Adult sections + some smaller academic ones. I also do a lot of background work and I manage the Facebook page of the shop.

<div class="clear"></div>

<figure class="text-center float-right pt-0 pl-5">
  <img src="/shop/gabor.png" alt="Gábor" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Gábor</figcaption>
</figure>

### Gábor

I worked for 6 years in various positions at Libri bookstores before joining Bestsellers in 2005. I read mainly fantasy, sometimes historical fiction/history or crime, or anything which looks interesting. My sections are: Fantasy, Science-Fiction, books in German, books in French, notebooks, and other shinies :) I'm an avid MMO player, GW2 rulez :) I'm in love with Prague, and started learning Czech recently.

<div class="clear"></div>

<figure class="text-center float-left pt-2 pr-5">
  <img src="/shop/mate.png" alt="Máté" class="w-max h-auto rounded-md m-2" />
  <figcaption class="italic text-sm">Máté</figcaption>
</figure>

### Máté

Behind many hairpin turns on my back I joined the Bestsellers Team in the Autumn of 2021.
I graduated from ELTE with a specialization in Philosophy and Film Theory so I can primarily help you find books on these two topics. I also have significant experience with theatre and I am interested in fantasy, sci-fi, and poetry. After finishing work I turn into a rapper and throw rhymes as the MC of the La Tascen Trum band or as a hobby programmer I develop my own roleplaying game, which needs a long time to be built.

<div class="clear"></div>

`;

</script>

<template>
  <div>
    <Head>
      <Title>{{ title }}</Title>
    </Head>
    <main
      class="px-2 sm:mx-auto md:mx-auto lg:mx-auto xl:mx-auto md:container lg:container xl:container"
    >
      <div class="grid grid-cols-12 gap-4">
        <!-- Left side content -->
        <div
          class="mt-8 col-span-12 md:col-span-8 lg:col-span-8 xl:col-span-8 flex shadow-lg rounded-md p-4 bg-boxbg-dark"
        >
          <MarkdownRender :content="locale === 'hu' ?  contenthu : contenten" />
        </div>
        <!-- right side bar -->
        <aside
          class="xs:hidden sm:hidden md:col-span-4 lg:col-span-4 xl:col-span-4"
        >
          <div class="sticky top-0 pt-40 pb-10 -mt-32">
            <div class="bg-boxbg-dark shadow-lg rounded-md">
              <img
                src="/shop/top_01.jpg"
                class="rounded-t-md"
                alt="Bestsellers"
                title="Bestsellers"
              />
              <nav
                class="p-4 mx-2 mb-5 overflow-y-scroll"
                style="max-height: 17rem"
              >
                <p class="font-bold mb-2">
                  <span class="text-navbg-dark text-lg">
                    <font-awesome-icon :icon="['fas', 'bookmark']"
                  /></span>
                  {{ title }}:
                </p>
                <ul><li class="toc-list"><a role="button" href="#about-bestsellers" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm underline"><span>About Bestsellers</span></a></li><li class="toc-list"><a role="button" href="#why-bestsellers" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline"><span>Why Bestsellers?</span></a></li><li class="toc-list pl-0 lg:pl-5 xl:pl-5"><a role="button" href="#we-are-price-competitive" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline" style="display: none;"><span>We are price competitive.</span></a></li><li class="toc-list"><a role="button" href="#members-of-our-team" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline"><span>Members of our team</span></a></li><li class="toc-list pl-0 lg:pl-5 xl:pl-5"><a role="button" href="#tony-lang" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline" style="display: none;"><span>Tony Lang</span></a></li><li class="toc-list pl-0 lg:pl-5 xl:pl-5"><a role="button" href="#kriszta" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline" style="display: none;"><span>Kriszta</span></a></li><li class="toc-list pl-0 lg:pl-5 xl:pl-5"><a role="button" href="#melinda" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline" style="display: none;"><span>Melinda</span></a></li><li class="toc-list pl-0 lg:pl-5 xl:pl-5"><a role="button" href="#gábor" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline" style="display: none;"><span>Gábor</span></a></li><li class="toc-list pl-0 lg:pl-5 xl:pl-5"><a role="button" href="#máté" class="transition-colors duration-75 mb-2 block font-sans font-light text-sm hover:underline" style="display: none;"><span>Máté</span></a></li></ul>
              </nav>
            </div>
            <ContactBar />
          </div>
        </aside>
      </div>
    </main>
  </div>
</template>
